<template>
  <div>
    <div class="modal-backdrop fade show" style="z-index: 10000">
      <div class="row justify-content-center h-100">
        <div class="align-self-center">
          <!-- Spinners aleatorios -->
          <component 
            :is="spinnerActual" 
            class="text-center" 
            :color="colorActual" 
            :size="sizeActual" 
          />
          <h4
            class="text-center text-light animate__animated animate__fadeIn animate__infinite pt-4"
            :style="{ marginLeft: spinnerActual === 'PacmanLoader' ? '20px' : '0' }"
          >
            {{ mensajeActual }}
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { 
  PacmanLoader,
  RingLoader,
  RotateLoader,
  ClipLoader,
  GridLoader,
  DotLoader,
  HashLoader,
  BounceLoader,
  CircleLoader,
  SquareLoader,
  MoonLoader,
  SkewLoader,
  PulseLoader
} from "@saeris/vue-spinners";
import "animate.css/animate.css";

export default {
  name: "LoadingSpinner",
  components: {
    PacmanLoader,
    RingLoader,
    RotateLoader,
    ClipLoader,
    GridLoader,
    DotLoader,
    HashLoader,
    BounceLoader,
    CircleLoader,
    SquareLoader,
    MoonLoader,
    SkewLoader,
    PulseLoader
  },
  data() {
    return {
      spinnerActual: 'PacmanLoader',
      colorActual: '#fff',
      sizeActual: 50,
      mensajeActual: 'Cargando...',
      // Lista de spinners disponibles
      spinners: [
        { nombre: 'PacmanLoader', size: 50 },
        { nombre: 'RingLoader', size: 60 },
        { nombre: 'RotateLoader', size: 15 },
        { nombre: 'ClipLoader', size: 50 },
        { nombre: 'GridLoader', size: 15 },
        { nombre: 'DotLoader', size: 60 },
        { nombre: 'HashLoader', size: 50 },
        { nombre: 'BounceLoader', size: 60 },
        { nombre: 'CircleLoader', size: 50 },
        { nombre: 'SquareLoader', size: 50 },
        { nombre: 'MoonLoader', size: 50 },
        { nombre: 'SkewLoader', size: 50 },
        { nombre: 'PulseLoader', size: 15 }
      ],
      // Colores disponibles
      colores: [
        '#ffffff', // Blanco
        '#17a2b8', // Info
        '#28a745', // Success
        '#ffc107', // Warning
        '#dc3545', // Danger
        '#6f42c1', // Purple
        '#e83e8c', // Pink
        '#20c997', // Teal
        '#fd7e14', // Orange
      ],
      // Mensajes aleatorios
      mensajes: [
        'Cargando...',
        'Procesando...',
        'Un momento...',
        'Preparando datos...',
        'Casi listo...',
        'Obteniendo información...',
        'Por favor espere...',
      ]
    };
  },
  created() {
    this.seleccionarAleatorio();
  },
  methods: {
    seleccionarAleatorio() {
      // Spinner aleatorio
      const spinnerRandom = this.spinners[Math.floor(Math.random() * this.spinners.length)];
      this.spinnerActual = spinnerRandom.nombre;
      this.sizeActual = spinnerRandom.size;
      
      // Color aleatorio
      this.colorActual = this.colores[Math.floor(Math.random() * this.colores.length)];
      
      // Mensaje aleatorio
      this.mensajeActual = this.mensajes[Math.floor(Math.random() * this.mensajes.length)];
    }
  }
};
</script>

<style>
.align-self-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.text-light {
  color: #fff;
}
</style>
